var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C454F",
  strokeLinecap: "round",
  d: "M9.839 9.546 3.475 3.182m0 6.364 6.364-6.364"
})));
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDEzIDEzIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik05LjgzODcyIDkuNTQ1OTRMMy40NzQ3NiAzLjE4MTk4TTMuNDc0NzYgOS41NDU5NEw5LjgzODcyIDMuMTgxOTgiIHN0cm9rZT0iIzNDNDU0RiIKICAgICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiIC8+Cjwvc3ZnPg==";